<section class="table-container">
    <app-custom-table [showRecover]="true" [headers]="header" [data]="data" [actions]="tableActions"
        [previousFilters]="filters" [isFilterPersistent]="false"
        (onRecoverData)="getAllOptionWindowUsersWithPagination()" (onAction)="onAction($event)"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
        <div tableExtraButtons class="d-flex gap-2">
            <app-custom-button class="buttons" [title]="'Asignar Todos'" [label]="'Asignar Todos'"
                [severity]="'success'" [icon]="'pi pi-check-circle'" (onClick)="assignAllPermissions()">
            </app-custom-button>
            <app-custom-button class="buttons" [title]="'Quitar Todos'" [label]="'Quitar Todos'" [severity]="'danger'"
                [icon]="'pi pi-times-circle'" (onClick)="removeAllPermissions()">
            </app-custom-button>
        </div>
    </app-custom-table>
</section>